import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { AppDataService, StaticDataService } from '../../services';


@Injectable({ providedIn: 'root' })
export class DashboardPageService {

	private readonly appData = inject(AppDataService);
	private readonly staticData = inject(StaticDataService);
	private readonly util = inject(UtilityService);
	private readonly router = inject(Router);


	private readonly _renderSvg = signal(false);
	public readonly renderSvg = this._renderSvg.asReadonly();
	public setRenderMode(svg: boolean) { this._renderSvg.set(svg); }
	public toggleRenderMode() { this._renderSvg.set(!this._renderSvg()); }
	

	//
	// Quick Filter Values
	//
	private _quickFilters = signal({ time: 0, map: new Map<string, any>() });
	public quickFilters = this._quickFilters.asReadonly();

	public setQuickFilter(field: string, value: string | number | boolean | undefined) {

		const time = Date.now();
		const filters = this._quickFilters();

		if (value == undefined) filters.map.delete(field);
		else filters.map.set(field, value);

		this._quickFilters.set({ time, map: filters.map });
	}

	public showQuickFiltersBar = computed(() => {
		if (this.showQuickFiltersPanel()) return true; // Bar is always shown when the panel is
		const filters = this.quickFilters();
		return filters.map.size > 0;
	});


	//
	// Quick Filters Panel
	//

	private _quickFiltersPanel = signal(false);
	public showQuickFiltersPanel = this._quickFiltersPanel.asReadonly();

	public toggleQuickFiltersPanel() {
		this._quickFiltersPanel.set(!this._quickFiltersPanel());
	}


	//
	// Temporary value toggler
	//

	public toggleQuickFilters() {
		const time = Date.now();
		const filters = this._quickFilters();
		if (filters.map.size) filters.map.clear();
		else filters.map.set('Time', time);

		this._quickFilters.set({ time, map: filters.map });
	}



}